export default "/icons/node-js.svg";